import React, { useEffect, useState } from 'react'
import { Momi } from '../../types/momiTypes';
import { ResponseAPIWithPagination } from '../../../../common/types/API.types';
import useQuerySelector from '../../../../common/hooks/useQuerySelector';
import momiAPI from '../../service/momiAPI';
import MicroModalSelectorSearch from '../../../../common/components/organisme/MicroModalSelectorSearch/MicroModalSelectorSearch';

export interface MomiSelectorProps {
    isError?: boolean;
    onChange: (momi: Momi | null) => void;
    value: Momi | null | undefined;
    variant?: "dark" | "light";
    initMomiId?: string | null;
    label?: string;
}

export default function MomiSelector({
    onChange, isError, value, variant = "light", initMomiId, label = "MoMi EMS"
}: MomiSelectorProps) {

    const [initLoaded, setInitLoaded] = useState(false);

    const { resultFound, isLoading, setValueQuery, valueQuery } = useQuerySelector<ResponseAPIWithPagination<Momi>>(
        {
            getSearch: (query: string) => {
                return momiAPI.getAllMomis(0, 0, query);
            }
        }
    );

    useEffect(() => {
        if (initMomiId && resultFound?.data && !initLoaded) {
            const found = resultFound.data.find(m => m.momi_id === initMomiId);
            if (found) {
                onChange(found);
                setInitLoaded(true);
            }
        }
    }, [resultFound, initMomiId, initLoaded]); // eslint-disable-line

    const onClickItem = (item: any) => {
        onChange(item.item);
    }

    const convertToResultItem = (momis: Momi[]) => {
        return momis.map((momi) => {
            return {
                id: momi.momi_id,
                name: momi.momi_name + " (" + momi.momi_uuid + ")",
                item: momi
            }
        })
    }

    return <MicroModalSelectorSearch
        valueSelectedName={value ? value.momi_name + " (" + value.momi_uuid + ")" : undefined}
        placeholder="Sélectionner un MoMi EMS"
        result={resultFound ? convertToResultItem(resultFound?.data || []) : []}
        setQuery={setValueQuery}
        onClickItem={onClickItem}
        isLoading={isLoading}
        valueQuery={valueQuery}
        isError={isError}
        emptyMessage="Aucun MoMi trouvé"
        variant={variant}
        label={label}
    />
};
